var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHomeFold = function() {
    var $slider = $('.home__fold_slider .slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        speed: 800,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        appendArrows: '.home__fold_slider .arrows',
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                dots: true
              }
            },
        ]
    });
}



// Slider - Featured
//-----------------------------------------------------------------
mp.sliderFeatured = function() {
    var $slider = $('.featured-slider .slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: true,
        dots: false,
        speed: 800,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        variableWidth: true,
        appendArrows: '.featured-slider .arrows',
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true
              }
            },
        ]
    });
}



// Slider - Articles Gallery
//-----------------------------------------------------------------
mp.sliderArticlesGallery = function() {
    var $element = $('.articles__gallery');

    if (!$element.length) {
        return;
    }

    var $slider = $('.articles__gallery .slider');
    var $slider_nav = $('.articles__gallery .slider-nav');


     $slider.slick({
        slidesToShow: 1,
        arrows: false,
        fade: true,
        swipe: false,
        asNavFor: $slider_nav
    });

    $slider_nav.slick({
        slidesToShow: 3,
        asNavFor: $slider,
        dots: false,
        focusOnSelect: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
    });
}




// Slider - Block - Gallery
//-----------------------------------------------------------------
mp.sliderBlockGallery = function() {
    var $slider = $('.gallery__slider .slider');

    if (!$slider.length) {
        return;
    }

    $slider.each( function() {
        $(this ).slick( {
            fade: true,
            arrows: true,
            dots: false,
            speed: 800,
            pauseOnFocus: false,
            pauseOnHover: false,
            infinite: true,
            slidesToShow: 1,
            appendArrows: $(this).parents('.gallery__slider').find('.arrows'),
            prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
        });
    });
}



// Slider - Events
//-----------------------------------------------------------------
mp.sliderEvents = function() {
    var $sliderEvents = $('.events__slider .slider');

    if (!$sliderEvents.length) {
        return;
    }

    $sliderEvents.slick({
        vertical: true,
        verticalSwiping: true,
        arrows: true,
        dots: false,
        speed: 800,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: false,
        slidesToShow: 1,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
    });
}




$(document).ready(function (){
    mp.sliderHomeFold();
    mp.sliderFeatured();;
    mp.sliderArticlesGallery();
    mp.sliderBlockGallery();
    mp.sliderEvents();
});